// extracted by mini-css-extract-plugin
export default {"Button":"IconButton_Button__LX5-V","Text":"IconButton_Text__QHCTi","Icon":"IconButton_Icon__w4mfv"};